module.exports = __webpack_public_path__ + "img/ElectronicChecks.af101f84.svg";